module.exports = __webpack_public_path__ + "static/young-boys-soccer.fe3b2587.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/young-boys-soccer.jpg
// module id = 482
// module chunks = 35783957827783